module.exports = __webpack_public_path__ + "static/media/main.42612c8e.svg";